module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./SelectDeliveryWayView.js"));
	}, "SelectDeliveryWayView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SelectDeliveryWayView!./src/pages/Shop/CheckOrder/SelectDeliveryWay/SelectDeliveryWayView.js
// module id = 886
// module chunks = 431